var _line, _line2, _line3, _line4, _line5, _line6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitleImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.1797,
    y1: 13.2432,
    x2: 18.7664,
    y2: 13.2432,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 5.08666,
    y2: -1.5,
    transform: "matrix(-1 0 0 1 33.4414 19.2305)",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.2734,
    y1: 13.2432,
    x2: 22.8201,
    y2: 13.2432,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 3.56667,
    y2: -1.5,
    transform: "matrix(-1 2.15681e-07 3.54354e-08 1 26.3477 19.2305)",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 26.3281,
    y1: 13.2432,
    x2: 32.4481,
    y2: 13.2432,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 8.63333,
    y2: -1.5,
    transform: "matrix(-1 2.10888e-07 3.62407e-08 1 20.7734 19.2305)",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 35,
    height: 22,
    rx: 3.5,
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitleImage);
export default __webpack_public_path__ + "static/media/SubtitleImage.09fb5d0836e23a8981f718c172fc8cb0.svg";
export { ForwardRef as ReactComponent };